var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4653_37664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 22.6155C17.8975 22.6155 22.6784 17.8629 22.6784 12.0002C22.6784 6.13744 17.8975 1.38477 11.9999 1.38477C6.10225 1.38477 1.32129 6.13744 1.32129 12.0002C1.32129 17.8629 6.10225 22.6155 11.9999 22.6155Z",
    fill: "#1F82FF",
    fillOpacity: 0.03,
    stroke: "#444444",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9447 15.8301C16.671 15.1857 16.2738 14.6003 15.7752 14.1066C15.2782 13.6115 14.6894 13.2167 14.0414 12.9441C14.0356 12.9413 14.0298 12.9398 14.024 12.9369C14.9279 12.2879 15.5155 11.2306 15.5155 10.0379C15.5155 8.06189 13.9051 6.46094 11.9173 6.46094C9.92958 6.46094 8.31909 8.06189 8.31909 10.0379C8.31909 11.2306 8.9067 12.2878 9.81061 12.9383C9.80481 12.9413 9.799 12.9426 9.7932 12.9455C9.1432 13.2182 8.55994 13.609 8.05938 14.108C7.5613 14.6022 7.16419 15.1875 6.88997 15.8316C6.62056 16.4622 6.47528 17.1384 6.46195 17.8234C6.46156 17.8388 6.46428 17.8542 6.46994 17.8685C6.4756 17.8828 6.48409 17.8959 6.49491 17.9069C6.50572 17.9179 6.51865 17.9267 6.53292 17.9326C6.54719 17.9386 6.56253 17.9418 6.57802 17.9418H7.44856C7.5124 17.9418 7.56318 17.8913 7.56463 17.8292C7.59365 16.7157 8.04342 15.6729 8.83851 14.8826C9.66117 14.0648 10.7537 13.6147 11.9173 13.6147C13.081 13.6147 14.1734 14.0648 14.9961 14.8826C15.7912 15.6729 16.241 16.7157 16.2699 17.8292C16.2714 17.8926 16.3222 17.9418 16.386 17.9418H17.2566C17.2721 17.9418 17.2874 17.9386 17.3017 17.9326C17.316 17.9267 17.3289 17.9179 17.3398 17.9069C17.3505 17.8959 17.359 17.8828 17.3646 17.8685C17.3703 17.8542 17.3731 17.8388 17.3726 17.8234C17.3581 17.134 17.2145 16.4634 16.9447 15.8301ZM11.9173 12.5187C11.2514 12.5187 10.6246 12.2605 10.153 11.7918C9.68148 11.3229 9.42177 10.6998 9.42177 10.0379C9.42177 9.37584 9.68148 8.75276 10.153 8.28401C10.6246 7.81527 11.2514 7.55709 11.9173 7.55709C12.5832 7.55709 13.21 7.81527 13.6816 8.28401C14.1532 8.75276 14.4128 9.37584 14.4128 10.0379C14.4128 10.6998 14.1532 11.3229 13.6816 11.7918C13.21 12.2605 12.5832 12.5187 11.9173 12.5187Z",
    fill: "#444444",
    stroke: "#444444",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4653_37664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2710f694768aa7cc1b273c569e644b78.svg";
export { ForwardRef as ReactComponent };